// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6f5f616d","977":"1d7e7826"}[chunkId] + ".chunk.js";
};